import {
  FontIcon,
  FontIcons,
  FontSizes,
  FontWeights,
  StandardHeading,
  StandardLink,
  StandardText
} from '@brandfolder/react';
import classNames from 'classnames';
import { FunctionComponent, HTMLAttributes, useContext } from 'react';
import styled from 'styled-components';

import { BrandguideContext } from '@context/brandguide';
import { WhitelabelContext } from '@context/whitelabel';

type SettingsManageUsersProps = HTMLAttributes<HTMLDivElement>;

const UnstyledSettingsManageUsers: FunctionComponent<SettingsManageUsersProps> = (props) => {
  const { brandfolder, collection } = useContext(BrandguideContext);
  const { whitelabel } = useContext(WhitelabelContext);

  const collectionOrBrandfolderSlug = () => {
    return collection ? `${brandfolder?.slug}/${collection.slug}` : `${brandfolder?.slug}`;
  };

  return (
    <div
      {...props}
      className={classNames({
        'global-settings__wrapper': true,
        [`${props.className}`]: !!props.className
      })}
    >
      <FontIcon className="manage-users" icon={FontIcons.UserSettings} iconSize={20} />
      <div className="manage-users-header-wrapper">
        <StandardHeading
          className="manage-users-header-wrapper__manage-users-text"
          size={FontSizes.XSmall}
          weight={FontWeights.Medium}
        >
          Users
        </StandardHeading>
        <StandardText className="manage-users-header-wrapper__manage-users-description">
          View all users, change permissions, remove users, view access requests, invite users, and
          manage invitations.
        </StandardText>
        <StandardLink
          className="manage-users-header-wrapper__manage-users-link"
          href={`${
            whitelabel.BOULDER_URL
          }/${collectionOrBrandfolderSlug()}/bulk_management#user_management`}
          target="_blank"
        >
          Manage all users
        </StandardLink>
      </div>
    </div>
  );
};

const StyledSettingsManageUsers = styled(UnstyledSettingsManageUsers)`
  display: flex;
  margin: 20px 0px;

  .manage-users {
    margin-right: 15px;
  }

  .manage-users-header-wrapper {
    &__manage-users-text {
      text-transform: uppercase;
    }

    &__manage-users-link {
      margin-top: 24px;
    }
  }
`;

export const SettingsManageUsers: FunctionComponent<SettingsManageUsersProps> = (props) => {
  return <StyledSettingsManageUsers {...props} />;
};
